<template>
  <div
    class="dnl:absolute dnl:inset-0 dnl:bg-white/[0.5] dnl:flex dnl:items-center dnl:justify-center dnl:z-100"
  >
    <BaseLoadingSpinner
      class="dnl:w-10 dnl:h-10"
      :class="spinnerClass"
    />
  </div>
</template>

<script setup lang="ts">
  import BaseLoadingSpinner from '@/components/BaseLoadingSpinner.vue';

  defineProps<{
    spinnerClass?: string;
  }>();
</script>
